import find from 'lodash-es/find';
import get from 'lodash-es/get';
import debounce from 'lodash-es/debounce';

/***
 * Пересчёт координат новой активной кнопки пагинации
 * @param swiper{Object} - объект слайдера
 */
const updateSize = (swiper) => {
	let active = find(swiper.pagination?.bullets, (bullet) => bullet.classList.contains('swiper-pagination-bullet-active'));
	if (!active) active = swiper.pagination?.bullets[0];
	if (!active) return;

	const sliderPagination = get(swiper, 'pagination.el.parentElement');
	if (!sliderPagination) return;

	sliderPagination.style.setProperty('--top', active.offsetTop + 'px');
	sliderPagination.style.setProperty('--left', active.offsetLeft + 'px');
	sliderPagination.style.setProperty('--width', active.offsetWidth + 'px');
};

export const PaginationEvents =  {
	resize: debounce((swiper) => updateSize(swiper), 250), //TODO Если на странице несколько слайдов, то resize отрабатывает некорректно. Пример: index.bemjson.js
	paginationUpdate: updateSize
};
